'use strict';

(function ($) {
    $.fn.removeClassByPrefix = function (prefix) {
        var self = this;

        self.each(function (i, el) {
            var regx = new RegExp('\\b' + prefix + '.* ?\\b', 'g');
            el.className = el.className.split(/\s+/).filter(function (cssClass) {
                return !regx.test(cssClass);
            }).join(' ');
        });

        return self;
    };

    $.fn.pqCompile = function ($scope) {
        var self = this;

        self.each(function (i, el) {
            var $injector = angular.injector(['ng', 'armPQApp']);

            $injector.invoke(["$compile", "$rootScope", function ($compile, $rootScope) {
                $compile(el)($scope || $rootScope);
                $rootScope.$digest();
            }]);
        });

        return self;
    };
})(jQuery);